module.exports = __webpack_public_path__ + "img/workflow_4.026bd1a4.jpg";